// Libraries
import {
  Directive,
  ElementRef,
  AfterViewInit
} from '@angular/core';

/**
 * `AutofocusDirective` Directive to set focus on the input.
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 * @export
 */
@Directive({
    selector: '[wpAutofocus]'
})
export class AutofocusDirective implements AfterViewInit {

  /**
   * Creates an instance of AutofocusDirective.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @param elem Element Ref
   * @memberof AutofocusDirective
   */
  constructor(
    private elem: ElementRef
  ) {
  }

  /**
   * Implements on after view init method
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof AutofocusDirective
   */
  public ngAfterViewInit() {
    this.elem.nativeElement.focus();
  }
}
